export const UserRoleConstants = {
  ADMIN: 1,
};
